import PropTypes from 'prop-types'
import React from 'react'
import './styles.css'

function Tooltip({ message }) {
  return (
    <div className="tooltip">
      <div className="tooltip-content">
        <div className="tooltip-content__icon" aria-label="More info">i</div>
        <div className="tooltip-content__message">{message}</div>
      </div>
    </div>
  )
}

Tooltip.propTypes = {
  message: PropTypes.string.isRequired
}

export default Tooltip
